/** Display delimiters only; the source pronunciation is left unchanged. */
export function formatIpa(ipa: string): string {
  let value = ipa.trim();
  if ((value.startsWith('/') && value.endsWith('/')) ||
      (value.startsWith('[') && value.endsWith(']'))) {
    value = value.slice(1, -1).trim();
  }
  return value ? `/${value}/` : '';
}
